var style = {"PicoLoaderContainer_modal":"Loading-module_PicoLoaderContainer_modal__5B3PN","PicoLoader_modal":"Loading-module_PicoLoader_modal__A-RxK","rotate-forever":"Loading-module_rotate-forever__tLcjf"};

export { style as default };
//# sourceMappingURL=Loading.module.scss.js.map
